<template>
  <div
    class="card-description"
    :class="[{ 'card-description--has-background': isShowingBackground }]"
    :style="`background-color: ${backgroundColor}`"
  >
    <div class="card-description__title">{{ productName }}</div>
    <div v-if="!isSummaryHidden" class="card-description__summary">
      {{ shortDescription }}
    </div>
    <div class="card-description__colors">{{ colorCount }} {{ $t(`product.${colorKey}`) }}</div>
    <div v-if="!isGiftCardProduct" class="card-description__price">
      {{ priceWithCurrency }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { format } from '@/helpers/currency-formatter'

export default {
  name: 'CardDescription',
  props: {
    backgroundColor: {
      type: String,
    },
    card: {
      type: Object,
      required: true,
    },
    productName: {
      type: String,
    },
    isShowingBackground: {
      type: Boolean,
      default: false,
    },
    isSummaryHidden: {
      type: Boolean,
      default: false,
    },
    isGiftCardProduct: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('store', ['currency']),

    colorCount() {
      return this.card.variants.length
    },

    colorKey() {
      return this.colorCount > 1 ? 'colors' : 'color'
    },

    priceWithCurrency() {
      const amount = Number(this.card.price)
      return this.card.price !== undefined ? format(amount, this.currency) : ''
    },

    shortDescription() {
      return this.card.productData?.shortDescription || ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import './CardDescription';
</style>
